import React from 'react';

export function CommonButton({ 
    label, 
    onClick, 
    type = 'button', 
    buttontheme = {} 
}) {
    const { 
        bgColor = '#FA5813FF', 
        textColor = '#fff', 
        borderColor = '#FA5813FF',
        // shadow = '0 4px 6px rgba(0,0,0,0.1)'
    } = buttontheme;

    return (
        <button
            type={type}
            className="p-button w-full h-2rem"
            style={{
                backgroundColor: bgColor,
                color: textColor,
                borderColor: borderColor,
                fontWeight: 'bold',
            }}
            onClick={onClick}
        >
            <span className="p-button-label">{label}</span>
        </button>
    );
}
